// extracted by mini-css-extract-plugin
export default {"labelDotsContainer":"LabelDots-module__labelDotsContainer--N8ZA_","labelDot":"LabelDots-module__labelDot--YelI4"};